import React from "react";

function DarkOrangeCircleGage(props) {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
    <path d="M15.3438 18.3537C19.2765 16.0831 20.6239 11.0541 18.3533 7.12121C16.0826 3.18828 11.0537 1.84069 7.12092 4.11127C3.18814 6.38186 1.84075 11.4108 4.11142 15.3437C6.3821 19.2767 11.411 20.6243 15.3438 18.3537Z" fill="#F37320" stroke="#262627" stroke-width="2"/>
  </svg>
  )
}
export default DarkOrangeCircleGage;